import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type CreateIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasPostData,
  type CreateIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasPostError,
  type CreateIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasPostResponse,
  createIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasPost,
} from '../../generated';

export type CreateIdeaMutationVariables = CreateIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasPostData['path'];

export type CreateIdeaMutation = CreateIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasPostResponse;

export const useCreateIdeaMutation = <
  TError = CreateIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<CreateIdeaMutation, TError, CreateIdeaMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<CreateIdeaMutation, TError, CreateIdeaMutationVariables, TContext>({
    mutationKey: ['CreateIdea'],
    mutationFn: async ({ workspace_id, image_id }: CreateIdeaMutationVariables) => {
      const { data } = await createIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasPost({
        path: { workspace_id, image_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useCreateIdeaMutation.fetcher = (
  { workspace_id, image_id }: CreateIdeaMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await createIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasPost({
      path: { workspace_id, image_id },
      throwOnError: true,
    });
    return data;
  };
};
